import type { FilterOperationSchema } from '../../types.js';

type Keys =
    | 'inArray'
    | 'equals'
    | 'doesNotEqual'
    | 'greaterThan'
    | 'greaterThanOrEqual'
    | 'lessThan'
    | 'lessThanOrEqual'
    | 'between';

export const NUMBER_FILTER_OPERATION: FilterOperationSchema<Keys> = {
    inArray: {
        id: 'inArray',
        label: 'Filterliste',
    },
    // ---
    equals: {
        id: 'equals',
        label: 'Gleich',
    },
    doesNotEqual: {
        id: 'doesNotEqual',
        label: 'Ungleich',
    },
    // ---
    greaterThan: {
        id: 'greaterThan',
        label: 'Größer als',
    },
    greaterThanOrEqual: {
        id: 'greaterThanOrEqual',
        label: 'Größer oder gleich',
    },
    lessThan: {
        id: 'lessThan',
        label: 'Kleiner als',
    },
    lessThanOrEqual: {
        id: 'lessThanOrEqual',
        label: 'Kleiner oder gleich',
    },
    between: {
        id: 'between',
        label: 'Zwischen',
    },
} as const;

export type NumberFilter = typeof NUMBER_FILTER_OPERATION;
export type NumberFilterValues = NumberFilter[keyof typeof NUMBER_FILTER_OPERATION];
export type NumberFilterValuesWithoutInArray = Exclude<NumberFilterValues, NumberFilter['inArray']>;
